var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _ellipse4, _rect, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartTradingNowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.0689 18.5335C64.9349 13.196 60.8757 8.99922 58.7965 7.09522C52.7009 2.78123 49.4649 2.31699 45.3832 1.73142L45.3029 1.71991C38.9463 0.807746 24.9196 0.891781 19.0978 2.61475C11.8205 4.76846 7.66212 9.07587 5.20488 13.5706C2.74763 18.0653 -0.0876465 25.1819 1.70803 39.4151C3.14458 50.8017 9.17438 54.9593 14.2778 57.7685L22.6892 62.0759L32.8016 66.5706C37.5271 64.6666 48.7737 59.8473 55.9564 55.802C64.9348 50.7455 66.636 41.6624 67.1085 39.4151C68.1126 34.6395 67.2915 24.288 66.0689 18.5335Z",
    fill: "url(#paint0_linear_1877_15395)",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6449 39.3086H66.6992L66.4167 40.7382L66.04 42.3583L65.4749 44.0738L64.7216 45.8846C59.6738 45.9608 55.7436 45.8528 55.2099 45.5987C54.2305 44.3025 54.4565 40.6111 54.6449 39.3086Z",
    stroke: "black",
    strokeWidth: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1364 17.0025C52.1185 12.4842 57.964 9.49321 60.2305 8.77153C54.0951 1.85123 46.4312 1.46963 38.9283 1.09605L38.7656 1.08795C32.6285 0.782088 21.2534 1.17129 15.4403 3.91196C8.45219 7.2066 4.58039 13.1369 2.78614 18.6907C0.991886 24.2445 0.614155 33.7518 1.36963 38.5526C2.26423 44.2374 3.9151 53.3933 11.8518 55.6845C20.6342 58.2198 31.7774 57.3726 41.1264 55.2138C49.3961 53.3043 50.2863 44.2087 50.6641 40.3485L50.6643 40.3472C51.042 36.4878 49.9088 22.6504 51.1364 17.0025Z",
    fill: "url(#paint1_linear_1877_15395)",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9332 33.2915C31.6493 35.8237 34.0521 38.4497 36.6658 38.4497C39.2796 38.4497 41.3984 35.3634 41.3984 33.2915C41.3984 31.2197 39.6947 28.4147 36.6658 28.4147C33.353 28.2271 31.9332 31.2197 31.9332 33.2915Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06214 33.2915C6.77818 35.8237 9.181 38.4497 11.7947 38.4497C14.4085 38.4497 16.5273 35.3634 16.5273 33.2915C16.5273 31.2197 14.8236 28.4147 11.7947 28.4147C8.48192 28.2271 7.06214 31.2197 7.06214 33.2915Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.79699,
    cy: 1.57826,
    rx: 1.79699,
    ry: 1.57826,
    transform: "matrix(-1 0 0 1 38.2344 30.2695)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.79699,
    cy: 1.57826,
    rx: 1.79699,
    ry: 1.57826,
    transform: "matrix(-1 0 0 1 13.5078 30.2695)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.359397,
    cy: 0.358695,
    rx: 0.359397,
    ry: 0.358695,
    transform: "matrix(-1 0 0 1 14.3711 32.9961)",
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.359397,
    cy: 0.358695,
    rx: 0.359397,
    ry: 0.358695,
    transform: "matrix(-1 0 0 1 39.0938 32.9961)",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8.91306,
    height: 2.29565,
    rx: 1.14783,
    transform: "matrix(-1 0 0 1 28.0273 45.0469)",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6052 42.6165C42.7923 39.4281 48.1467 39.1055 50.5977 39.3902C50.3149 44.8938 49.9378 47.6457 47.4868 51.0618C45.5395 53.7758 42.3963 55.1421 39.0969 55.5216V47.7406C39.0969 44.6092 40.1339 43.4072 40.6052 42.6165Z",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.227 17.8998C55.2571 16.3798 58.9548 14.3265 60.9622 13.3398L63.1016 19.0998C61.6436 19.2918 56.5249 22.0598 54.0685 26.5398L53.0384 21.1798C53.0913 20.8332 53.282 19.2943 54.227 17.8998Z",
    fill: "#CAA2FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2274 54.1113L64.2539 46.3398L63.7255 47.3144L63.1216 48.3639C62.3182 49.5569 61.0894 51.3969 59.0815 53.0865C57.4747 54.4386 56.184 55.319 52.9705 56.8301L49.3071 58.7838L39.3732 59.0425L28.3212 59.3835L18.5831 59.6833L12.0918 56.4005L11.6381 56.0131C19.0267 58.0148 33.4281 57.3722 41.221 55.9406L52.2274 54.1113Z",
    fill: "#7057F0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.703 60.2578H38.7787L34.4961 64.7056L44.703 60.2578Z",
    fill: "#383740"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8676 40.7422H64.9727L64.2538 42.9613L56.1072 43.0378C55.7238 42.5481 55.7078 41.3033 55.8676 40.7422Z",
    fill: "#826CF7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4069 60.543H37.1489L32.625 65.4212L43.4069 60.543Z",
    fill: "#634AE4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8789 59.1094L18.3957 60.0836L21.6948 61.8372L22.826 62.4218L23.5801 62.8115L32.8176 67.0007L37.2479 65.1496L41.6782 63.1037L49.8789 59.1094Z",
    fill: "#7057F0",
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7038 60.543H37.5445L33.2031 65.4212L44.7038 60.543Z",
    fill: "#644AE7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1877_15395",
    x1: 60.6582,
    y1: 9.82496,
    x2: 42.1325,
    y2: 66.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B589FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491707,
    stopColor: "#AF86FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738033,
    stopColor: "#866FF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806CF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1877_15395",
    x1: 30.6161,
    y1: 0.999999,
    x2: 55.7562,
    y2: 81.2324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453744,
    stopColor: "#F3EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCA6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartTradingNowIcon);
export default __webpack_public_path__ + "static/media/StartTradingNowIcon.c36adb2c69a35f89878870069ae42a6c.svg";
export { ForwardRef as ReactComponent };